import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';
import { getFavoritesRequestParams } from '../common/favoritesServiceHelper';

export function getWebViewerLicenses() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_licenses'
      })
    }
  );
};

export function getWebViewerLicenseById(licenseId) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_license_by_id',
        id: licenseId,
      })
    }
  );
};

export function addWebViewerLicense(serverId, featurePackages = null, count = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'add_web_viewer_license',
        server_id: serverId,
        feature_packages: featurePackages,
        count
      })
    }
  );
};

export function editWebViewerLicense(licenseId, featurePackages) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'edit_web_viewer_license',
        license_id: licenseId,
        feature_packages: featurePackages
      })
    }
  );
};

export function getWebViewerLicenseHistory(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_license_history',
        license_id: licenseId
      })
    }
  ).then(history => history)
    .catch(error => {
      throw error
    });
};

export function getWebViewerLicenseHistoryById(id = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_license_history_by_id',
        id
      })
    }
  )
};

export function removeWebViewerLicenses(licenseIds = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'remove_web_viewer_licenses',
        license_ids: licenseIds
      })
    }
  );
}

export function restoreWebViewerLicenses(licenseIds = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'restore_web_viewer_licenses',
        license_ids: licenseIds
      })
    }
  );
}

export function getWebViewerLicenseLivingStates() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_web_viewer_license_living_states'
      })
    }
  );
}

export function addWebViewerLicenseToFavorites(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'web_viewer_license', 'add', licenseId
    )
  );
}

export function removeWebViewerLicenseFromFavorites(licenseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'web_viewer_license', 'remove', licenseId
    )
  );
}



// WEBPACK FOOTER //
// ./src/services/webViewerLicenses.js